import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const dayNames = {
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    full: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};

const monthNames = {
    abbreviated: ["Jan", "Feb", "Mar", "Apr","May", "Jun", "Jul", "Aug","Sep", "Oct", "Nov", "Dec"],
    full: ["January", "February", "March", "April","May", "June", "July", "August","September", "October", "November", "December"]
};

/**
 * Convert Date Time String to formatted output
 * @returns {string|null} - Returns formatted date time.
 * @param inputDate
 * @param format
 */
export function formatDate(inputDate, format = 'yyyy-MM-dd'){

    if (!inputDate) {
        return null;
    }

    const date = new Date(inputDate);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() +1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const dayFull =  dayNames.full[date.getDay()];
    const dayAbbreviation = dayNames.abbreviated[date.getDay()];
    const monthFull =  monthNames.full[date.getMonth()];
    const monthAbbreviation = monthNames.abbreviated[date.getMonth()];

    // Replace format tokens with corresponding values
    return format
        .replace('yyyy', year)
        .replace('MMMM', monthFull)
        .replace('MMM', monthAbbreviation)
        .replace('MM', month)
        .replace('ddd', dayAbbreviation)
        .replace('dddd', dayFull)
        .replace('dd', day)
        .replace('HH', hour)
        .replace('hh', hour > 12 ? (hour - 12).toString().padStart(2, '0') : hour)
        .replace('tt', hour > 12 ? 'PM' : 'AM')
        .replace('mm', minutes);
}

/**
 * Convert Date Time String to formatted Timestamp
 * @returns {string|null} - Returns formatted date time.
 * @param inputDate
 * @param format
 */
export function formatToTimestamp(inputDate, format = 'yyyy-MM-dd'){

    if (!inputDate) {
        return null;
    }

    const nowUtc = dayjs().utc();
    const inputUtc = dayjs.utc(inputDate);

    const diffMinutes = nowUtc.diff(inputUtc, 'minute', false);
    const diffHours = nowUtc.diff(inputUtc, 'hour', false);

    if (diffMinutes < 1) {
        return 'Just now';
    }

    if (diffMinutes < 60) {
        return `${diffMinutes} min${diffMinutes === 1 ? '' : 's'} ago`;
    }

    if (diffHours <= 12) {
        return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
    }

    return formatDate(inputDate, format);
}